module.exports = __webpack_public_path__ + "img/18.6cdce89e.jpg";